import { render } from "./PlanArgenIframe.vue?vue&type=template&id=4d3705ee&ts=true"
import script from "./PlanArgenIframe.ts?vue&type=script&lang=ts&external"
export * from "./PlanArgenIframe.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__